<template>
  <div class="login-page login-bg overflow-hidden">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page d-flex flex-column">
      <div id="particles-js"></div>
      <img
        src="static/img/central-gym150x150.webp"
        class="mx-auto mb-1 over logo"
        style="width: 150px"
        alt=""
        slot="header"
      />
      <template v-if="!showUpdatePassword">
        <card type="login" class="mb-1 over login-card mx-auto">
          <form @submit.prevent="login">
            <h3 slot="header" class="header text-center">Bienvenido</h3>
            
            <!-- Selector de tipo de usuario -->
            <div class="user-type-selector mb-3">
              <label class="form-label text-center d-block mb-2">Tipo de Acceso</label>
              <div class="radio-group">
                <div class="form-check-custom">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="userType" 
                    id="adminType" 
                    value="admin" 
                    v-model="userType"
                  >
                  <label class="form-check-label" for="adminType">
                    Ingresar como Administrador
                  </label>
                </div>
                <div class="form-check-custom">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="userType" 
                    id="trainerType" 
                    value="trainer" 
                    v-model="userType"
                  >
                  <label class="form-check-label" for="trainerType">
                    Ingresar como Personal Trainer
                  </label>
                </div>
              </div>
            </div>

            <fg-input
              v-model="form.username"
              addon-left-icon="nc-icon nc-single-02"
              placeholder="Usuario..."
              :disabled="userType === 'trainer'"
            ></fg-input>

            <fg-input
              v-model="form.password"
              addon-left-icon="nc-icon nc-key-25"
              placeholder="Contraseña ..."
              type="password"
              :disabled="userType === 'trainer'"
            ></fg-input>

            <br />

            <p-button
              native-type="submit"
              slot="footer"
              type="success"
              round
              block
              class="mb-3 mx-auto w-75 w-md-50"
              >Iniciar Sesion</p-button
            >
            <p class="text-center text-muted small mb-0">
              App Version: {{ appVersion }} {{ appEnv }}
            </p>
          </form>
        </card>
      </template>
      <template v-else>
        <card type="login" class="mb-1 over login-card mx-auto">
          <form>
            <h3 slot="header" class="header text-center">
              Actualizar Contraseña
            </h3>
            <label for="">Nueva contraseña</label>
            <fg-input
              v-model="form.newPassword"
              addon-left-icon="nc-icon nc-key-25"
              placeholder="Nueva contraseña ..."
              type="password"
            ></fg-input>
            <label for="">Confirme contraseña</label>
            <fg-input
              v-model="form.newPasswordRepeat"
              addon-left-icon="nc-icon nc-key-25"
              placeholder="Nueva contraseña ..."
              type="password"
            ></fg-input>
            <small class="text-danger">{{ passwordUpdateErrorMessage }}</small>

            <br />
            <p-button
              slot="footer"
              type="success"
              round
              block
              @click="updatePassword"
              class="mb-3 mx-auto w-75 w-md-50"
              :disabled="
                form.newPassword && form.newPassword !== form.newPasswordRepeat
              "
              >Actualizar</p-button
            >
          </form>
        </card>
      </template>
      <span class="text-center text-light font-weight-light text-monospace mt-0"
        >Fecha de lanzamiento: {{ $store.state.appReleaseDate }}</span
      >
      <!-- <div class="full-page login-page section-image"> -->
      <div class="full-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <!-- <div class="content d-flex flex-column" style="padding-top: 100px">
          <div class="container mt-0 mb-0">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto d-flex flex-column"> -->
        <!-- <img
                src="static/img/central-gym150x150.webp"
                class="mx-auto mb-1 over"
                style="width: 150px"
                alt=""
                slot="header"
              /> -->
        <!-- <template v-if="!showUpdatePassword">
                <card type="login" class="mb-1 over">
                  <form @submit.prevent="login">
                    <h3 slot="header" class="header text-center">Bienvenido</h3>
                    <fg-input
                      v-model="form.username"
                      addon-left-icon="nc-icon nc-single-02"
                      placeholder="Usuario..."
                    ></fg-input>

                    <fg-input
                      v-model="form.password"
                      addon-left-icon="nc-icon nc-key-25"
                      placeholder="Contraseña ..."
                      type="password"
                    ></fg-input>

                    <br />

                    <p-button
                      native-type="submit"
                      slot="footer"
                      type="success"
                      round
                      block
                      class="mb-3 mx-auto w-75 w-md-50"
                      >Iniciar Sesion</p-button
                    >
                  </form>
                </card>
              </template> -->
        <!-- Update Password -->
        <!-- <form v-else @submit.prevent="updatePassword"> -->
        <!-- <template v-else>
                <card type="login" class="mb-1">
                  <form>
                    <h3 slot="header" class="header text-center">
                      Actualizar Contraseña
                    </h3>
                    <label for="">Nueva contraseña</label>
                    <fg-input
                      v-model="form.newPassword"
                      addon-left-icon="nc-icon nc-key-25"
                      placeholder="Nueva contraseña ..."
                      type="password"
                    ></fg-input>
                    <label for="">Confirme contraseña</label>
                    <fg-input
                      v-model="form.newPasswordRepeat"
                      addon-left-icon="nc-icon nc-key-25"
                      placeholder="Nueva contraseña ..."
                      type="password"
                    ></fg-input>
                    <small class="text-danger">{{
                      passwordUpdateErrorMessage
                    }}</small>

                    <br />
                    <p-button
                      slot="footer"
                      type="success"
                      round
                      block
                      @click="updatePassword"
                      class="mb-3 mx-auto w-75 w-md-50"
                      :disabled="
                        form.newPassword &&
                        form.newPassword !== form.newPasswordRepeat
                      "
                      >Actualizar</p-button
                    >
                  </form>
                </card>
              </template> -->
        <!-- </div>
          </div> -->
        <!-- <span
            class="text-center text-muted font-weight-light text-monospace mt-0"
            >versión: {{ $store.getters.getSWV }} || lanzamiento:
            {{ $store.getters.getReleaseDate }}</span
          > -->
        <!-- </div> -->
        <app-footer></app-footer>
        <!-- <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg)"
        ></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import axios from "axios";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { text } from "d3";
import { timeout } from "d3";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },
  computed: {
    passwordUpdateErrorMessage() {
      if (
        this.form.newPassword &&
        this.form.newPassword !== this.form.newPasswordRepeat
      ) {
        return "Ambas contraseñas deben coincidir";
      }
    },
  },
  data() {
    return {
      showUpdatePassword: false,
      appVersion: this.$store.state.appVersion, //process.env.VUE_APP_BUILD_VERSION || '0.0',
      appEnv: this.$store.state.appEnv, //process.env.VUE_APP_BUILD_MODE === '1' ? '(dev)' : process.env.VUE_APP_BUILD_MODE === '2' ? '(test)' : '(prod)',
      userType: 'admin', // Por defecto administrador
      form: {
        username: "",
        password: "",
        newPassword: "",
        newPasswordRepeat: "",
      },
    };
  },
  watch: {
    userType(newType) {
      if (newType === 'trainer') {
        // Llenar automáticamente con credenciales demo
        this.form.username = 'personaltrainer';
        this.form.password = '123456';
      } else {
        // Limpiar campos cuando se selecciona administrador
        this.form.username = '';
        this.form.password = '';
      }
    }
  },
  mounted() {
    this.initParticles();
  },
  created() {
    console.log('BUILD VERSION:', process.env.VUE_APP_BUILD_VERSION);
  },
  beforeDestroy() {
    // Promise.all([this.getConfig()]);
    this.closeMenu();
  },
  methods: {
    showSwal(mensajeServicio, title, ico) {
      let swalOptions = {
        title: title,
        icon: ico,
        text: mensajeServicio,
        confirmButtonColor: `#6bd098`,
      };
      swal.fire(swalOptions);
    },
    showWelcomeSwal(mensajeServicio, title, ico, time) {
      let swalOptions = {
        title: title,
        icon: ico,
        text: mensajeServicio,
        timer: time, // Timer habilitado para cierre automático
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      };
      swal.fire(swalOptions);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    async login() {
      // handle login here
      this.$swal.fire({
        title: "Cargando...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      
      // Manejar login de Personal Trainer DEMO
      if (this.userType === 'trainer') {
        this.$swal.close();
        // Configurar datos demo para personal trainer
        const demoUserData = {
          usuarioSesion: 'personaltrainer',
          email: 'demo@personaltrainer.com',
          perfilCuenta: { glosa: 'PERSONAL_TRAINER' },
          empresa: { _id: 'demo-company' },
          sucursales: [{ _id: 'demo-branch', nombreSucursal: 'Sucursal Demo' }]
        };
        
        this.$store.commit("setUserData", demoUserData);
        sessionStorage.setItem("jCxbraoQeD", "demo-token");
        sessionStorage.setItem("eId", "demo-company");
        sessionStorage.setItem("account-type", "PERSONAL_TRAINER");
        sessionStorage.setItem("WHbUjdv3TG", "personaltrainer");
        sessionStorage.setItem("email", "demo@personaltrainer.com");
        sessionStorage.setItem("nu5za9cv6q", "demo-branch");
        sessionStorage.setItem("qtsb4ec3d8", "Sucursal Demo");
        sessionStorage.setItem("xxxwypt5ip", JSON.stringify([{_id: 'demo-branch', nombreSucursal: 'Sucursal Demo'}]));
        
        this.showWelcomeSwal(
          "Modo DEMO activado",
          "Bienvenido Personal Trainer",
          "success",
          2000
        );
        
        // Redirigir al dashboard de personal trainer
        setTimeout(() => {
          this.$swal.close();
          this.$router.push("/trainer");
        }, 2000);
        return;
      }
      
      const user = this.form.username;
      const password = this.form.password;
      if (user && password) {
        await this.$axiosLogin
          .post(this.$Operations.Login, {
            Header: {
              Operacion: this.$Operations.Login,
            },
            Body: {
              idAplicacion: this.$store.getters.getAPPId,
              usuarioSesion: this.form.username,
              password: this.form.password,
            },
          })
          .then((result) => {
            this.$swal.close();
            let response = result.data.Response;
            let formatedBranches = [];
            if (
              response.Resultado.CodigoHTTP === 200 ||
              response.Resultado.CodigoHTTP === 201
            ) {
              if (
                response.DataOut.perfilCuenta.glosa === "SOPORTE" ||
                response.DataOut.perfilCuenta.glosa === "ADMINISTRADOR"
              ) {
                // console.log(response.DataOut);
                this.$store.commit("setUserData", response.DataOut);
                // console.log("this.$store.getters.getUserData");
                // console.log(this.$store.getters.getUserData);
                sessionStorage.setItem("jCxbraoQeD", response.Auth.Token);
                sessionStorage.setItem("eId", response.DataOut.empresa._id);
                // sessionStorage.setItem(
                //   "user-data",
                //   JSON.stringify(response.DataOut)
                // );
                sessionStorage.setItem(
                  "account-type",
                  response.DataOut.perfilCuenta.glosa
                );

                sessionStorage.setItem(
                  "WHbUjdv3TG",
                  response.DataOut.usuarioSesion
                );
                response.DataOut.sucursales.forEach((branch) => {
                  formatedBranches.push({
                    _id: branch._id,
                    nombreSucursal: branch.nombreSucursal,
                  });
                });
                sessionStorage.setItem("email", response.DataOut.email);
                sessionStorage.setItem(
                  "nu5za9cv6q",
                  response.DataOut.sucursales[0]._id
                ); //idSucursal
                sessionStorage.setItem(
                  "qtsb4ec3d8",
                  response.DataOut.sucursales[0].nombreSucursal
                ); //nombreSucursal
                sessionStorage.setItem(
                  "xxxwypt5ip",
                  JSON.stringify(formatedBranches)
                ); //array sucursales

                if (response.DataOut.actualizarPassword) {
                  sessionStorage.setItem("jCxbraoQeD", response.Auth.Token);
                  this.$swal
                    .fire({
                      title: "Debes Actualizar tu contraseña",
                      icon: "info",
                      showConfirmButton: true,
                    })
                    .then((res) => {
                      if (res.isConfirmed) {
                        this.showUpdatePassword = true;
                      }
                    });
                } else {
                  sessionStorage.removeItem("isLocked");
                  this.showWelcomeSwal(
                    "Iniciando sesión",
                    "Bienvenido/a",
                    "success",
                    2000
                  );
                  this.getConfig();
                }
              } else {
                let mensajeServicio =
                  "Parece que esta área no es accesible con tu perfil actual.";
                let CodigoHTTP = "¡Vaya!";
                this.showSwal(mensajeServicio, CodigoHTTP, "error");
              }
            } else {
              // console.log(response);
            }
          })
          .catch((err) => {
            this.$swal.close();
            // console.error("ERROR");
            // console.error("ERROR: ", err);
            // console.log(err);
            let mensajeServicio;
            let CodigoHTTP;
            if (err.response) {
              mensajeServicio =
                err.response.data.Response.Resultado.MensajeServicio;
              CodigoHTTP = err.response.data.Response.Resultado.CodigoHTTP;
            } else {
              mensajeServicio = `${
                err.message || "Error inesperado"
              } - Vuelve a intentarlo mas tarde o ponte en contacto con soporte`;
              CodigoHTTP = err.code;
              // console.log(err);
            }
            this.showSwal(mensajeServicio, CodigoHTTP, "error");
          });
      } else {
        this.$swal.fire({
          title: "Nombre de usuario o contraseña incorrectos",
          icon: "warning",
          confirmButtonColor: `#6bd098`,
        });
      }
    },
    async updatePassword() {
      this.$swal.fire({
        title: "Actualizando contraseña",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        await this.$axiosLogin
          .post(
            this.$Operations.UpdatePassword,
            {
              Header: {
                Operacion: this.$Operations.UpdatePasswordOP,
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Body: {
                passwordActual: this.form.password,
                nuevaPassword: this.form.newPassword,
                nuevaPasswordRepetir: this.form.newPasswordRepeat,
              },
            },
            {
              timeout: 5000, // Tiempo en milisegundos, aquí 5000ms (5 segundos)
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: this.$Operations.UpdatePasswordOP,
              },
            }
          )
          .then((res) => {
            const response = res.data.Response;
            // console.log(response.DataOut);
            // console.log("response*************************");
            // console.log(response);
            if (
              response.Resultado.CodigoHTTP === 200 ||
              response.Resultado.CodigoHTTP === 201
            ) {
              this.showWelcomeSwal(
                "Iniciando sesión",
                "Bienvenido/a",
                "success",
                2000
              );
              this.getConfig();
            } else {
              this.$swal.fire({
                title: "Error :(!",
                text:
                  response.Resultado.MensajeServicio ||
                  "Ha ocurrido un error al actualizar tu contraseña, por favor ponte en contacto con soporte",
                icon: "error",
                confirmButtonColor: "#6bd098",
              });
            }
          })
          .catch((ex) => {
            this.$swal.fire({
              title: "Error! :(",
              text:
                ex.response.data.Response.Resultado.MensajeServicio ||
                "Ha ocurrido un error inesperado, ponte en contacto con soporte",
              icon: "error",
              confirmButtonColor: "#6bd098",
            });
            // console.log(ex.message);
            // console.log(ex.config);
            // console.log(ex.request);
            // console.log(ex.transformResponse);
            // console.log("ex.message***********************************");
            // console.log(ex);
          });
      } catch (ex) {
        this.$swal.fire({
          title: "error",
          icon: "error",
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async getConfig() {
      try {
        const config = await this.$MasterControlAPP.post(
          "",
          {},
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: this.$Operations.GetConfig,
            },
          }
        );

        let oldState = this.$store.getters.getOPAll;
        //this.$store.commit('setEndpoints', {...oldState, ...config.data.Operations})
        // console.log("config******************************");
        // console.log(config.data);
        sessionStorage.setItem(
          "wxZlBbdD4q",
          JSON.stringify({ ...oldState, ...config.data.Operations })
        );
        sessionStorage.setItem("URLs", JSON.stringify(config.data.URLs));
        sessionStorage.setItem("Charts", JSON.stringify(config.data.ChartsId));
      } catch (ex) {
        // console.error("getConfig ++++");
        // console.error(ex);
      } finally {
        // console.log("NUEVOS ENDPOINTS")
        // console.log(this.$store.getters.getOPAll)
        // console.log("***********************************************")
        // Cerrar cualquier modal de SweetAlert antes de redirigir
        this.$swal.close();
        this.$router.push("/");
      }
    },
    initParticles() {
      particlesJS("particles-js", {
        particles: {
          number: { value: 100, density: { enable: true, value_area: 800 } },
          color: { value: "#ffffff" },
          shape: { type: "circle" },
          opacity: { value: 0.5, random: true },
          size: { value: 3, random: true },
          move: {
            enable: true,
            speed: 1,
            direction: "none",
            random: true,
            out_mode: "out",
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "push" },
          },
          modes: {
            repulse: { distance: 100, duration: 0.4 },
            push: { particles_nb: 4 },
          },
        },
      });
    },
  }
};
</script>
<style>
.login-bg {
  background-color: #001a00;
}
.over {
  /* background-color: rgba(255, 255, 255, 0.9); */
  /* padding: 30px; */
  /* border-radius: 10px; */
  /* box-shadow: 0 0 20px rgba(0, 255, 0, 0.2); */
  z-index: 6;
  /* position: relative; */
}
.logo {
  margin-top: 150px;
}
.login-card {
  width: 350px;
}
#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
}

/* Estilos para selector de tipo de usuario */
.user-type-selector {
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin-bottom: 20px;
}

.user-type-selector .form-label {
  color: #666;
  font-weight: 500;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px !important;
}

.radio-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.form-check-custom {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 250px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.form-check-custom:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: #6bd098;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-check-custom .form-check-input {
  margin-top: 0;
  margin-right: 10px;
  flex-shrink: 0;
}

.form-check-custom .form-check-input:checked {
  background-color: #6bd098;
  border-color: #6bd098;
}

.form-check-custom .form-check-label {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  margin: 0;
  flex: 1;
  transition: all 0.3s ease;
}

.form-check-custom:hover .form-check-label {
  color: #222;
  font-weight: 500;
}

.form-check-custom .form-check-input:checked + .form-check-label {
  color: #6bd098;
  font-weight: 600;
}

/* Estilos para campos deshabilitados */
.form-control:disabled {
  background-color: #f8f9fa;
  opacity: 0.7;
}
</style>
